import CrudBaseService from "@/services/CrudBaseService";

export default class ProductNetworkService extends CrudBaseService {
  constructor() {
    super('odoo/product_network');
  }

  getRegionsByPlan(planId) {
    return this.http.get(`${this._serviceName}/regionsByPlan`, { params: {planId} });
  }

}
